import React from 'react';
import { useAppConfig } from '~/hooks/useAppConfig';
import { mixpanel } from '~/third_party/Mixpanel.jsx';
import CardGridSection from './ui-kit/CardGridSection/CardGridSection';

const sectionProps = {
  background: '#F9F9F9',
  descriptionStyle: { color: '#9B9B9B' },
  title: 'Discover our platform',
  handleLinkClick: ({ text, url }) => {
    mixpanel.track({
      name: `discover our platform: user clicked ${text}`,
      properties: {
        text,
        url,
      },
    });
  },
};

const DINE_CARD = {
  heading: 'Dine with Us',
  image: {
    url: '/restaurants/man-sitting-outdoors-with-chowbus-bag.png',
    alt: 'Man sitting outdoors with Chowbus bag',
    height: 220,
    width: 300,
  },
  description: 'Explore new Asian cuisines and dishes delivered right to your door.',
  link: {
    text: 'Download the App',
    url: '/download',
  },
};

const PARTNER_CARD = {
  heading: 'Partner with Us',
  image: {
    url: '/restaurants/four-restaurant-workers.png',
    alt: 'Man sitting outdoors with Chowbus bag',
    height: 220,
    width: 300,
  },
  description: 'Grow your business and introduce your cuisine to even more customers.',
  link: {
    text: 'Sign Up',
    url: '/restaurants',
  },
};

const DELIVER_CARD = {
  heading: 'Deliver with Us',
  image: {
    url: '/restaurants/three-chowbus-drivers.png',
    alt: 'Man sitting outdoors with Chowbus bag',
    height: 220,
    width: 300,
  },
  description: 'Find flexible earning opportunities for any schedule.',
  link: {
    text: 'Start Delivering',
    url: '/drivers',
  },
};

function DiscoverOurPlatform() {
  const { isAlipay } = useAppConfig();
  const cards = isAlipay ? [PARTNER_CARD, DELIVER_CARD] : [DINE_CARD, PARTNER_CARD, DELIVER_CARD];
  return <CardGridSection cards={cards} columnCount={cards.length} {...sectionProps} />;
}

export default DiscoverOurPlatform;
